import React from 'react';
import { connect } from 'react-redux';
import { scheduleCalendarOperations } from 'pages/ScheduleCalendar/duck';
import timeUtil from 'pages/ScheduleCalendar/duck/timeUtil';
import VTODroppableCellBox from './VTODroppableCellBox';

const mapStateToProps = ({
  scheduleCalendarReducer,
  appReducer,
}) => {
  return {
    allUsers: scheduleCalendarReducer.allUsers.users,
    roles: appReducer.roles.data,
  };
};

const mapDispatchToProps = (dispatch) => {

    const copyVTOToDateDispatch = (shiftToCopy, date, locationId) => {
        const targetStartTime = timeUtil.pastedShiftStartTime(shiftToCopy, date);
        const targetEndTime = timeUtil.pastedShiftEndtime(shiftToCopy, date);
        const targetJobTitle = shiftToCopy.primary_job;
        const channelId = shiftToCopy.channel_id;
        const content = shiftToCopy.content;
        const total = shiftToCopy.total_shifts_available;
        const roleIds = shiftToCopy.non_filter_tag_ids;
        const skillIds = shiftToCopy.skill_ids;
        dispatch(scheduleCalendarOperations.addDraftVTOToUserOnDateOperation(shiftToCopy.owner_id, targetStartTime, targetEndTime, targetJobTitle, locationId,channelId, content, total, roleIds, skillIds))
      }

    const moveDraftVTODispatch = (shift, targetDate) => {

        var isMoveToNewDate = false;
        var targetStartTime = null;
        var targetEndTime = null;
  
        if( timeUtil.haveSameDate(shift.start_at, targetDate) == false) {
          isMoveToNewDate = true;
          //Calculate targetStartTime & targetEndTime
          targetStartTime = timeUtil.calculateTargetTime(shift.start_at, targetDate);
          const diff = timeUtil.shiftDuration(shift.start_at, shift.end_at);
          targetEndTime = timeUtil.addTimeDiffTo(targetStartTime, diff);
  
          console.log("From: " + shift.start_at + " - " + shift.end_at + ' to ' + targetStartTime + ' -'  + targetEndTime);
        }else{
          console.log("Same Day: " + shift.start_at + ' - ' + targetDate);
        }

        const roleIds = shift.non_filter_tag_ids;

        if( isMoveToNewDate == true ) {
            updateDraftVTODispatch(shift.id, shift.owner_id, targetStartTime, targetEndTime, shift.primary_job, shift.location_id, targetDate, shift.channel_id, shift.total_shifts_available, shift.content, roleIds, shift.skill_ids);
        }
    }

    const deleteDraftVTODispatch = (shiftId, locationId) => {
        dispatch(scheduleCalendarOperations.deleteShiftOperation(shiftId, locationId));
    };

    const updateDraftVTODispatch = (shiftId, currentUserId, startDateTime, endDateTime, jobTitle, locationId, date, channelId, quantity, shiftDescription, roleIds, skillIds) => {
        deleteDraftVTODispatch(shiftId, locationId)
        dispatch(scheduleCalendarOperations.addDraftVTOToUserOnDateOperation(currentUserId, startDateTime, endDateTime,jobTitle, locationId, channelId, shiftDescription, quantity, roleIds, skillIds));
    }

  return {
    moveDraftVTODispatch,
    copyVTOToDateDispatch,
  };
};

const VTODroppableCellBoxContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)((props) => {
  const {
    user,
    date,
    shiftsForDay,
    weekRangeStart,
    selectedDateToAddShift,
    isCopyingShift,
    shiftToCopy,
    
    allUsers,
    selectedShiftToViewDetail,

    copyVTOToDateDispatch,
    moveDraftVTODispatch,
    roles,
    } = props;

   return <VTODroppableCellBox
        user={user} 
        date={date} 
        shiftsForDay={shiftsForDay} 
        weekRangeStart={weekRangeStart}
        selectedDateToAddShift={selectedDateToAddShift} 
        selectedShiftToViewDetail = {selectedShiftToViewDetail}
        copyVTOToDateDispatch={copyVTOToDateDispatch} 
        isCopyingShift={isCopyingShift} 
        shiftToCopy={shiftToCopy}
        moveDraftVTODispatch = {moveDraftVTODispatch}
        allUsers = {allUsers} 
        roles = {roles}
   />
});

export default VTODroppableCellBoxContainer; 